// extracted by mini-css-extract-plugin
export default {"tabs":"d_l","tab-list":"d_m","tab":"d_n","active":"d_p"};